export default "__VITE_ASSET__92cbcee5__"